import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Livello_2"
    width={48}
    height={48}
    data-name="Livello 2"
    {...props}
  >
    <defs>
      <style>
        {
          ".cls-1{fill:none;stroke:#060b0c;stroke-miterlimit:10}.cls-3,.cls-4{fill:#060b0c;stroke-width:0}.cls-4{fill:#00a4b7}"
        }
      </style>
    </defs>
    <g id="Palette">
      <circle cx={24} cy={24} r={24} className="cls-4" />
      <path
        d="m20.25 10.3 12.14 6.87v13.67l-12.14 6.87-12.14-6.87V17.17l12.14-6.87m0-2.3L6.11 16v16l14.14 8 14.14-8V16L20.25 8Z"
        className="cls-3"
      />
      <path
        d="M7.11 16.58 20.25 24l13.14-7.42M20.25 38.85V24"
        className="cls-1"
      />
      <circle cx={33.39} cy={31.5} r={7.5} className="cls-4" />
      <path
        d="M33.39 25c3.58 0 6.5 2.92 6.5 6.5s-2.92 6.5-6.5 6.5-6.5-2.92-6.5-6.5 2.92-6.5 6.5-6.5m0-2c-4.69 0-8.5 3.81-8.5 8.5s3.81 8.5 8.5 8.5 8.5-3.81 8.5-8.5-3.81-8.5-8.5-8.5Z"
        className="cls-3"
      />
      <circle cx={33.39} cy={28} r={1} className="cls-3" />
      <path
        d="M33.39 36v-6"
        style={{
          strokeWidth: 2,
          fill: "none",
          stroke: "#060b0c",
          strokeMiterlimit: 10,
        }}
      />
    </g>
  </svg>
)
export default SvgComponent
